<template>
    <div>
        <div v-if="!authenticated">
            <p>You are not logged in, or your session has expired.</p>
            <div class="flex flex-col">
                <select
                    id="endpoint"
                    v-model="endpoint"
                    name="endpoint"
                >
                    <option
                        v-for="endpointAvailable in endpoints"
                        :key="endpointAvailable.name"
                        :value="endpointAvailable.url"
                    >
                        {{ endpointAvailable.name }}
                    </option>
                </select>
                <div>
                    e-mail: <input
                        v-model="email"
                        type="text"
                        name="email"
                    ><br>
                </div>
                <div>
                    password: <input
                        v-model="password"
                        type="text"
                        name="password"
                    ><br>
                </div>
            </div>
            <button @click="login">
                Login
            </button>
        </div>

        <small v-else>
            {{ selectedEndpoint }} - You are successfully authenticated <button @click="logout">Logout</button>
        </small>
    </div>
</template>

<script>
export default {
    name: 'Authentication',
    data() {
        return {
            email: '',
            password: '',
            endpoints: [
                { url: `${process.env.VUE_APP_BASE_URL}/api`, name: 'Lokaal (Jelle)' },
                { url: 'http://192.168.178.20:8090/api', name: 'Lokaal (Leo)' },
                { url: 'https://hermes-sandbox-v1.dfac.pro/api', name: 'Hermes Sandbox' },
                { url: 'https://hermes-v1.dfac.pro/api', name: 'Hermes Productie' },
            ],
        };
    },
    computed: {
        authenticated() {
            return this.$store.getters['auth/isAuthenticated'];
        },
        endpoint: {
            set(value) {
                this.$store.commit('auth/AUTH_SET_URL', value);
            },
            get() {
                return this.$store.state.auth.url;
            },
        },
        selectedEndpoint() {
            return this.endpoints.find((endpoint) => endpoint.url === this.endpoint).name;
        },
    },
    methods: {
        login() {
            this.$store.dispatch('auth/authenticate', {
                grant_type: 'password',
                username: this.email,
                password: this.password,
            });
        },
        logout() {
            this.$store.dispatch('auth/removeToken');
        },
    },
};
</script>

<style>
button {
  font-size: 14px;
}
</style>
